import { render } from "./Video.vue?vue&type=template&id=e88d50ac&scoped=true&ts=true"
import script from "./Video.ts?vue&type=script&lang=ts"
export * from "./Video.ts?vue&type=script&lang=ts"

import "./Video.scss?vue&type=style&index=0&id=e88d50ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88d50ac"]])

export default __exports__